// src/components/FloatingButtons/FloatingButtons.jsx

import React from 'react';
import { FaWhatsapp, FaPhoneAlt } from 'react-icons/fa';
import './FloatingButtons.css'; // Birazdan oluşturacağız

const FloatingButtons = () => {
  // --- Kanka, bu numaraları kendi numaralarınla değiştirmeyi unutma! ---
  
  // WhatsApp Numarası:
  // Ülke koduyla (90) başla, başında + olmadan ve boşluksuz.
  const whatsappNumber = "905327233567"; 
  
  // Arama Numarası:
  // Ülke koduyla (+90) başla veya normal (0555) formatında yaz.
  const phoneNumber = "+905327233567";    

  return (
    <>
      {/* ===== WhatsApp Butonu (Sol-Alt) ===== */}
      <a 
        href={`https://wa.me/${whatsappNumber}`} 
        className="floating-btn whatsapp-btn"
        target="_blank" // Yeni sekmede açar
        rel="noopener noreferrer" // Güvenlik için
        aria-label="WhatsApp ile iletişime geçin"
      >
        <FaWhatsapp className="floating-icon" />
      </a>

      {/* ===== Telefon Butonu (Sağ-Alt) ===== */}
      <a 
        href={`tel:${phoneNumber}`} 
        className="floating-btn phone-btn"
        aria-label="Telefonla arayın"
      >
        <FaPhoneAlt className="floating-icon" />
      </a>
    </>
  );
}

export default FloatingButtons;